module.exports = __webpack_public_path__ + "img/archived-tree.a834ab0d.svg";